/** "15 Sep 18:40" — when a version or a draft was made. */
export function fmtAiWhen(iso: string | null): string {
  if (!iso) return "";
  return new Date(iso).toLocaleString([], { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

/** Where the florist's pick landed: "1st", "2nd", … or "not offered". */
export function pickPlace(rank: number | null): string {
  if (rank === null) return "not offered";
  const tail = rank % 100 >= 11 && rank % 100 <= 13 ? "th" : ({ 1: "st", 2: "nd", 3: "rd" } as Record<number, string>)[rank % 10] ?? "th";
  return `${rank}${tail}`;
}
